<div class="container-fluid section-card form p-0">
  <div class="text-left pt-3 ps-3 mb-3">
    <h3 class="profile-title">Zona de acción</h3>
  </div>

  <div class="px-3 pb-3">
    <indu-map [center]="center" [source]="'supplier'" [zoom]="9" [circleCenter]="circleCenter"
      [drawZone]="enableCircleClick" (deleteZone)="onLocalDelete($event)" (setZone)="onLocalUpdate($event)">
    </indu-map>
  </div>

  <div class="line mt-2"></div>

  <div class="d-flex justify-content-end p-3 gap-2">
    @if (enableCircleClick) {
    <button class="no-back-color" (click)="saveAllChanges()">
      Guardar Cambios
    </button>
    <button class="no-back-color" (click)="cancelEdits()">
      Cancelar
    </button>
    } @else {
    <button class="no-back-color" (click)="toggleEditMode()" [disabled]="!usrSvc.hasPermission('delete:workingArea')">
      {{ circleCenter.length > 0 ? 'Editar Zonas' : 'Agregar Zona' }}
    </button>
    }
  </div>
</div>